import { ILoyaltyPromotionInput, LoyaltyPromotionType } from 'generated/graphql-gateway';
import {
  IAppliedRewards,
  IIncentiveEvaluationResult,
  IncentiveEvaluationMap,
} from 'state/loyalty/hooks/types';
import { LoyaltyAppliedOffer, LoyaltyOffer } from 'state/loyalty/types';
import { SyncStorageKey, syncStorage } from 'utils/environment/sync-storage';

export const getAppliedOffersFromStorage = () => {
  return syncStorage.getObject<LoyaltyAppliedOffer[]>(SyncStorageKey.APPLIED_LOYALTY_OFFERS) ?? [];
};

export const updateAppliedOffersInStorage = (appliedOffers: LoyaltyAppliedOffer[]) => {
  syncStorage.setObject(SyncStorageKey.APPLIED_LOYALTY_OFFERS, appliedOffers);
};

export const removeAppliedOffersInStorage = () => {
  syncStorage.remove(SyncStorageKey.APPLIED_LOYALTY_OFFERS);
};

export const getSelectedOfferFromStorage = () => {
  const storedAppliedOffers = syncStorage.getObject<LoyaltyOffer | null>(
    SyncStorageKey.SELECTED_LOYALTY_OFFER
  );
  return storedAppliedOffers;
};

export const updateSelectedOfferInStorage = (selectedOffer: LoyaltyOffer | null) => {
  syncStorage.setObject(SyncStorageKey.SELECTED_LOYALTY_OFFER, selectedOffer);
};

export const removeSelectedOfferInStorage = () => {
  syncStorage.remove(SyncStorageKey.SELECTED_LOYALTY_OFFER);
};

export const parseOffer = ({
  cartId: lineId,
  id,
}: LoyaltyAppliedOffer): ILoyaltyPromotionInput | null => {
  let result: ILoyaltyPromotionInput | null = null;
  if (id) {
    result = {
      id,
      lineId,
      type: LoyaltyPromotionType.OFFER,
    };
  }

  return result;
};

export const parseReward = (
  appliedReward: IAppliedRewards[string],
  cartId: string
): ILoyaltyPromotionInput => {
  return {
    id: appliedReward.rewardId,
    lineId: cartId,
    type: LoyaltyPromotionType.REWARD,
  };
};

export const parseOffers = (appliedLoyaltyOffers: LoyaltyAppliedOffer[]) =>
  appliedLoyaltyOffers.reduce((acc: ILoyaltyPromotionInput[], offer: LoyaltyAppliedOffer) => {
    const parsedOffer = parseOffer(offer);
    if (parsedOffer) {
      acc.push(parsedOffer);
    }

    return acc;
  }, []);

export const incentiveErrorsFilteredList = (
  offersFeedbackMap: IncentiveEvaluationMap,
  filterCallback: (item: IIncentiveEvaluationResult) => boolean
) => {
  return Object.values(offersFeedbackMap)
    .flat()
    .filter((item): item is IIncentiveEvaluationResult => item !== null && filterCallback(item));
};
